import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { addHistorySearch } from '../../common/search/addHistorySearchLocal';
import { PATH_NAME } from '../../configs/pathName';
import { SEARCH_QUERY } from '../../constant/queryURLKey';
import { ISearchHeaderProps } from '../../interfaces/components/index.interface';
import QRScanButton from '../buttons/QRScanButton';
import SearchInput from '../input/SearchInput';

const HistorySearch = dynamic(() => import('../elements/HistorySearch'), {
  ssr: false, //set SSR to false in order to user window object
});

const SearchHeader: React.FC<ISearchHeaderProps> = ({
  isShowHistorySearch,
  setIsShowHistorySearch,
}) => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState<string>(() => {
    const { searchKey } = router.query;
    if (typeof searchKey === 'string' && searchKey) return searchKey;
    return '';
  });

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="relative mx-3 mt-5 sm:mx-0"
    >
      <div className="absolute top-0 -mt-5 hidden h-[156px] w-full sm:block">
        <Image
          src={'/search-header-background.svg'}
          alt="search header background"
          layout="fill"
          objectFit="cover"
        />
      </div>

      {/* search header on mobile */}
      <div className="relative -mx-3 flex justify-between gap-2 px-3 sm:hidden">
        <SearchInput
          onFocus={() => {
            setIsShowHistorySearch(true);
          }}
          icon={<AiOutlineSearch size={20} />}
          value={searchValue}
          setValue={(value: any) => {
            setSearchValue(value);
            setIsShowHistorySearch(true);
          }}
          placeholder={'Tìm kiếm bạn bè'}
          className={`sm:text-md w-[70vw] text-[13px] ${
            !isShowHistorySearch ? 'z-40' : 'z-[90]'
          }`}
          redirectAfterClear={PATH_NAME.NETWORK}
          callBackAfterSubmit={() =>
            router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${searchValue}`)
          }
        />
        <div className="sm:text-md absolute left-0 right-0 top-full z-[90] h-auto w-full overflow-hidden rounded-md text-[14px]">
          <HistorySearch
            visible={isShowHistorySearch}
            onClick={(item: any) => {
              addHistorySearch(item);
              router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${item}`);
              setIsShowHistorySearch(false);
            }}
          />
        </div>
        <div className="text-[12px]">
          <QRScanButton />
        </div>
      </div>

      {/* search header on desktop */}
      <div className="ml-[50px] mt-7 hidden justify-start px-6 sm:flex lg:ml-0 lg:px-20">
        <div className="relative">
          <SearchInput
            onFocus={() => {
              setIsShowHistorySearch(true);
            }}
            icon={<AiOutlineSearch size={20} />}
            value={searchValue}
            setValue={(value: any) => {
              setSearchValue(value);
              setIsShowHistorySearch(true);
            }}
            placeholder={'Tìm kiếm bạn bè'}
            className={`w-[50vw] ${!isShowHistorySearch ? 'z-0' : 'z-[90]'}`}
            redirectAfterClear={PATH_NAME.NETWORK}
            callBackAfterSubmit={() =>
              router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${searchValue}`)
            }
          />
          <div className="absolute left-0 right-0 top-full z-[90] h-auto w-full overflow-hidden rounded-md">
            <HistorySearch
              visible={isShowHistorySearch}
              onClick={(item: any) => {
                addHistorySearch(item);
                router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${item}`);
                setIsShowHistorySearch(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SearchHeader;
